module.exports = __webpack_public_path__ + "static/teamextension_icon-0d14f90d4e12b5f7caf48896d7cdef28.svg";